// extracted by mini-css-extract-plugin
module.exports = {"roleButton":"role-button_roleButton__cUvL1","selected":"role-button_selected__ZFLR8","header":"role-button_header__YCwdH","icon":"role-button_icon__hp5if"};